import React from 'react';

import LazyLoad from 'react-lazyload';

import { Link, withPrefix } from 'gatsby';
import { css } from '@emotion/core';
import ButtonLink from '../../components/ui/ButtonLink';
import { colors } from '../../styles/colors';
import config from '../../website-config';

const Wrapper = css`
  h2.tools {
    text-align: center;
    font-size: 3.5rem;
    margin-bottom: 3.5rem;
  }
  .tools-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 4rem;
    text-align: center;
    max-width: 1200px;
    margin: 0 auto;
  }
  .tools-grid a {
    text-decoration: ${colors.beta} 1px underline;
    transition: text-decoration 0.25s;
  }
  
  .tools-grid a:hover {
    text-decoration: ${colors.alpha} 1px underline;
  }

  .tools-grid figcaption {
    text-decoration: none;
  }
 

  @media (max-width: 650px) { 
    h2.tools {
      font-size: 2.4rem;
    }
    .tools-grid {
      grid-template-columns: 1fr;
      grid-gap: 0;
    }
  }

  .tools-grid img {
    box-shadow: rgba(39, 44, 49, 0.06) 8px 14px 38px, rgba(39, 44, 49, 0.03) 1px 3px 8px;
    border-radius: 5px;
    transition: all 0.5s ease;
    margin-bottom: 2rem;
  }
  .tools-grid img:hover {
    transform: scale(1.03);
    box-shadow: rgba(39, 44, 49, 0.07) 8px 28px 50px, rgba(39, 44, 49, 0.04) 1px 6px 12px;
  }
`;

const MoreGoodies = (props) => {
  return (
    <div css={Wrapper}>
      <h2 className="tools">More Tools / Free Resources</h2>
      <div className="tools-grid">
        {props.slug !== 'free-luts' && (
          <LazyLoad height={325}>
            <Link to="/free-luts/" title="Free Photoshop LUTs">
              <figure>
                <img src={withPrefix("/covers/free-luts-3.jpg")} alt="" /> 
                <figcaption>Free LUTs for Photoshop</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}
        {props.slug !== 'capture-one-styles' && (
          <LazyLoad height={325}>
            <Link to="/capture-one-styles/" title="Free Capture One styles">
              <figure>
                <img src={withPrefix("/covers/capture-one-styles-s.jpg")} alt="" />
                <figcaption>25 Free Capture One Styles</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}
        {props.slug !== 'texture-overlays' && (
          <LazyLoad height={325}>
            <Link to="/texture-overlays/" title="Free texture overlays">
              <figure>
                <img src={withPrefix("/covers/texture-overlays.jpg")} alt="" />
                <figcaption>Free Texture Overlays for Photoshop</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}
        {props.slug !== 'light-leaks' && (
          <LazyLoad height={325}>
            <Link to="/light-leaks/" title="22 Free Light Leaks">
              <figure>
                <img src={withPrefix("/covers/light-leaks.jpg")} alt="" />
                <figcaption>22 Free Light Leaks</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}

        {props.slug !== 'bokeh-overlays' && (
          <LazyLoad height={325}>
            <Link to="/bokeh-overlays/" title="220 Free Bokeh Overlays">
              <figure>
                <img src={withPrefix("/covers/bokeh-overlays.jpg")} alt="" />
                <figcaption>220 Free Bokeh Overlays</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}

        {props.slug !== 'color-grading' && (
          <LazyLoad height={325}>
            <Link to="/color-grading/" title="Preview different color grades">
              <figure>
                <img src={withPrefix("/covers/color-grading-s.jpg")} alt="" />
                <figcaption>Color grading helper with Photoshop actions</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}

        {props.slug !== 'black-and-white-converter' && (
          <LazyLoad height={325}>
            <Link to="/black-and-white-converter/" title="convert images to black and white">
              <figure>
                <img src={withPrefix("/covers/black-and-white-converter-s.jpg")} alt="" />
                <figcaption>Convert images to black and white</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}

        {props.slug !== 'duotone-generator' && (
          <LazyLoad height={325}>
            <Link to="/duotone-generator/" title="Duotone Generator">
              <figure>
                <img src={withPrefix("/covers/duotone-generator-s.jpg")} alt="" />
                <figcaption>Duotone Generator/Previewer</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}

        {props.slug !== 'complementary-colors' && (
          <LazyLoad height={325}>
            <Link to="/complementary-colors/" title="Complementary Color Picker">
              <figure>
                <img src={withPrefix("/covers/complementary-colors.svg")} alt="" />
                <figcaption>Complementary Color Picker</figcaption>
              </figure>
            </Link>
          </LazyLoad>
        )}
      </div>
      <div className="text-center t3">
        <ButtonLink href="/guide/tools/">All Resources &amp; Tools</ButtonLink>
      </div>
    </div>
  );
};

export default MoreGoodies;
